import { render, staticRenderFns } from "./CatPerfForm.vue?vue&type=template&id=dcfa4672&scoped=true&"
import script from "./CatPerfForm.vue?vue&type=script&lang=js&"
export * from "./CatPerfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa4672",
  null
  
)

export default component.exports